import { countOnPage } from '../shared/static.countOnPage'

import {
  REQUEST_CHANGE_SAVED_REPORTS_FILTER,
  READY_CHANGE_SAVED_REPORTS_FILTER,
} from '../actions/filterSavedReportsActions'

import { states } from './queriesStates'

const initialState = {
  dataState: states.NOT_REQUESTED,
  count: countOnPage[0].value,
  page: 1,
}

const filterSavedReportsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_CHANGE_SAVED_REPORTS_FILTER: {
      return Object.assign(
        {},
        state,
        {
          dataState: states.REQUEST,
        }
      )
    }
    case READY_CHANGE_SAVED_REPORTS_FILTER: {
      return Object.assign(
        {},
        state,
        {
          dataState: states.READY,
          page: action.page
        }
      )
    }
    default:
      return state
  }
}

export default filterSavedReportsReducer
